import { render, staticRenderFns } from "./managerProp.vue?vue&type=template&id=983aa384&scoped=true&"
import script from "./managerProp.vue?vue&type=script&lang=js&"
export * from "./managerProp.vue?vue&type=script&lang=js&"
import style0 from "./managerProp.vue?vue&type=style&index=0&id=983aa384&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983aa384",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('983aa384')) {
      api.createRecord('983aa384', component.options)
    } else {
      api.reload('983aa384', component.options)
    }
    module.hot.accept("./managerProp.vue?vue&type=template&id=983aa384&scoped=true&", function () {
      api.rerender('983aa384', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/activity/attractingCustomers/detail/managerProp.vue"
export default component.exports